"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createSearchIndex = function createSearchIndex(_ref) {
  var _sys$environment, _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var site = process.env.NEXT_PUBLIC_SITE;
  var env = (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$environment = sys.environment) === null || _sys$environment === void 0 ? void 0 : _sys$environment.sys, 'id');
  var indexName = (0, _utils.getProp)(fields, 'indexName');
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    indexName: site && env && indexName ? "".concat(site, "_").concat(env, "_").concat(indexName) : null,
    params: _objectSpread({
      hitsPerPage: (0, _utils.getProp)(fields, 'hitsPerPage') || 0
    }, fields === null || fields === void 0 ? void 0 : fields.params)
  };
};
var createSearchGroup = function createSearchGroup(_ref2) {
  var _sys$contentType2;
  var sys = _ref2.sys,
    fields = _ref2.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)((_sys$contentType2 = sys.contentType) === null || _sys$contentType2 === void 0 ? void 0 : _sys$contentType2.sys, 'id'),
    title: (0, _utils.getProp)(fields, 'title'),
    indexes: (0, _utils.getProp)(fields, 'indexes') ? fields === null || fields === void 0 ? void 0 : fields.indexes.map(function (index) {
      return createSearchIndex(index);
    }) : null
  };
};
var createSearchInput = function createSearchInput(_ref3) {
  var _sys$contentType3;
  var sys = _ref3.sys,
    fields = _ref3.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType3 = sys.contentType) === null || _sys$contentType3 === void 0 ? void 0 : _sys$contentType3.sys, 'id'),
    location: (0, _utils.getProp)(fields, 'location'),
    placeholder: (0, _utils.getProp)(fields, 'placeholder'),
    openSearch: (0, _utils.getProp)(fields, 'openSearch'),
    closeSearch: (0, _utils.getProp)(fields, 'closeSearch'),
    searchGroups: (0, _utils.getProp)(fields, 'searchGroups') ? fields.searchGroups.map(function (group) {
      return createSearchGroup(group);
    }) : null,
    offSet: (0, _utils.getProp)(fields, 'offSet')
  };
};
var _default = createSearchInput;
exports["default"] = _default;